 /*
   * @Author: zhaoshuai11
   * @Date: 2025-08-20 16:04:18
 * @LastEditors: zhaoshuai11
 * @LastEditTime: 2025-12-02 14:37:39
   * @Description:
   *
   */
  
  // import Api from '../../../../../utils/business/api/index.js';
  import axios from 'axios';
  export default {
  /**
   * @Description：请求配置信息
   * @params String appId 应用Id
   * @params String clusterName 集群名
   * @params String namespaceName 命名空间
   */
  getConfig({ appId, clusterName, namespaceName }) {
    return axios({
      baseURL: '',
      method: 'get',
      url: `/configfiles/json/${appId}/${clusterName}/${namespaceName}`
    });
  }
};
//   export default class ConfigApi extends Api {
//     constructor({ axios, type, domain }) {
//       super({
//         axios,
//         type,
//         domain
//       });
//     }
  
//  async getConfig({ appId, clusterName, namespaceName }) {
//     return axios({
//        baseURL: '',
//       method: 'get',
//       url: `/configfiles/json/${appId}/${clusterName}/${namespaceName}`
//     });
//   }
//   }
  